import { Box } from '@mui/material'
import { Card } from 'packages/eid-ui'
import { usePageContext } from 'pageContext'
import { useTranslation } from 'react-i18next'
import GenericFilter from '../EidFilter/GenericFilter'

const InboxTypeFilter = () => {
    const { t } = useTranslation()
    const [state] = usePageContext()

    return (
        <Card
            cardTitle={t('InboxType')}
            collapsible
            expanded={Boolean(state.inboxType)}
        >
            <Box
                padding="0"
                style={{
                    borderTop: 'solid 1px #efeff1',
                    backgroundColor: '#fbfbfd',
                }}
            >
                <Box padding="20px 20px 0px 20px">
                    <GenericFilter
                        type="checklist"
                        searchable={false}
                        searchPlaceholder={t('Search')}
                        url="/api/CSVInbox/types"
                        dedupingInterval="1800000"
                        debounceInterval="500"
                        contextProp="inboxType"
                        selectedValueIndicatorProp="name"
                        state={state}
                        showPagination={false}
                        transformResponse={(data) => {
                            return data.map((item) => ({
                                id: item.csvInboxTypeID,
                                friendlyName: item.friendlyName || item.name,
                                ...item,
                            }))
                        }}
                    />
                </Box>
            </Box>
        </Card>
    )
}

export default InboxTypeFilter
